import type { SVGProps } from 'react';

const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M31 6.67H7.73v-.2a4.5 4.5 0 0 0-4.48-4h-3V4h3a3 3 0 0 1 3 2.66l1.5 13.64a5 5 0 0 0 2.43 3.7 3.19 3.19 0 1 0 5.34 2.35 3.14 3.14 0 0 0-.52-1.71h9.4a3.2 3.2 0 1 0 5.91 1.68 3.2 3.2 0 0 0-3.2-3.19H12.66a3.49 3.49 0 0 1-3.46-3h18.47a2.76 2.76 0 0 0 2.73-2.39l1.34-10.22a.71.71 0 0 0-.18-.59.73.73 0 0 0-.56-.26M12.33 28A1.7 1.7 0 1 1 14 26.32 1.7 1.7 0 0 1 12.33 28m16.51-1.7A1.7 1.7 0 1 1 27 24.64h.16a1.7 1.7 0 0 1 1.68 1.68Zm.07-8.79a1.25 1.25 0 0 1-1.24 1.09H9L7.89 8.17h22.25Z"
      data-name="shopping_cart"
    />
  </svg>
);

export default SvgShoppingCart;
